import { lazy } from 'react';
import { TenantRouteMeta } from '../types';

const Cohorts = lazy(() => import('../../pages/ProgramYear/Cohorts'));
// ActionCohorts (was: `program-year/action-cohorts`) — retired. Cohort
// assignment moved inline onto the action edit page (see Actions/ActionEdit).
const ContentList = lazy(() => import('../../pages/Content/ContentList'));
const ContentEdit = lazy(() => import('../../pages/Content/ContentEdit'));
const WalletTransferRules = lazy(() => import('../../pages/ProgramYear/WalletTransferRules'));
const RewardsCatalog = lazy(() => import('../../pages/Rewards/RewardsCatalog'));
const Communications = lazy(() => import('../../pages/Communications/Communications'));
const AuditLog = lazy(() => import('../../pages/AuditLog/AuditLog'));
const Segments = lazy(() => import('../../pages/Segments/Segments'));
const MilestonesPage = lazy(() => import('../../pages/Milestones/MilestonesPage'));

// Static PrototypeV3 reference — gated devOnly
const V3Currencies = lazy(() => import('../../pages/PrototypeV3/screens/Currencies'));

export const programYearRoutes: TenantRouteMeta[] = [
  {
    path: 'program-year/currencies',
    element: <V3Currencies />,
    devOnly: true,
    role: 'admin',
    permission: 'super-admin',
    sidebar: { group: 'program-year', label: 'Currencies', order: 1, adminOnly: true },
  },
  {
    path: 'program-year/cohorts',
    element: <Cohorts />,
    permission: 'config',
    sidebar: { group: 'program-year', label: 'Cohorts', order: 2 },
  },
  {
    path: 'program-year/content',
    element: <ContentList />,
    role: 'admin',
    permission: 'super-admin',
    sidebar: { group: 'program-year', label: 'Content', order: 4, adminOnly: true },
  },
  {
    path: 'program-year/content/:componentCode',
    element: <ContentEdit />,
    permission: 'super-admin',
  },
  {
    path: 'program-year/rewards',
    element: <RewardsCatalog />,
    role: 'admin',
    permission: 'super-admin',
    sidebar: { group: 'program-year', label: 'Rewards', order: 5, adminOnly: true },
  },
  {
    path: 'program-year/wallet-transfer-rules',
    element: <WalletTransferRules />,
    role: 'admin',
    permission: 'super-admin',
    sidebar: { group: 'program-year', label: 'Wallet Transfer Rules', order: 6, adminOnly: true },
  },
  {
    path: 'program-year/comms',
    element: <Communications />,
    role: 'admin',
    permission: 'super-admin',
    sidebar: { group: 'program-year', label: 'Communications', order: 7, adminOnly: true },
  },
  {
    path: 'program-year/audit',
    element: <AuditLog />,
    role: 'admin',
    permission: 'super-admin',
    sidebar: { group: 'program-year', label: 'Audit Log', order: 8, adminOnly: true },
  },
  {
    path: 'program-year/segments',
    element: <Segments />,
    role: 'admin',
    permission: 'super-admin',
    sidebar: { group: 'program-year', label: 'Segments', order: 9, adminOnly: true },
  },
  {
    path: 'program-year/milestones',
    element: <MilestonesPage />,
    permission: 'milestones',
    sidebar: { group: 'milestones', label: 'Milestones', order: 1 },
  },
];
